import { Router } from '@angular/router';
import { AuthService } from '@riise/core/services/firebase/auth.service';
import { Injectable, inject } from '@angular/core';
import { NotificationPush } from '@riise/shared/directives/notification-push.directive';
import { UserData } from '@riise/shared/utils/constants/users';
import { CryptoService } from '@riise/core/services/crypto/crypto.service';
import { StateService } from '@riise/core/services/state/state.service';
import { MatDialog } from '@angular/material/dialog';
import { AnnouncementsService } from '@riise/core/services/announcements/announcements.service';
import { NotificationsService } from '@riise/core/services/notifications/notifications.service';


@Injectable({
  providedIn: 'root',
})
export class NotificationRouter {
  private auth = inject(AuthService);
  private router = inject(Router);
  private userData = inject(UserData);

  private NotificationPush = inject(NotificationPush);
  private stateService = inject(StateService);
  private crypto = inject(CryptoService);
  private dialog = inject(MatDialog);
  private announcementsService = inject(AnnouncementsService);
  private notificationsService = inject(NotificationsService);


  space = this.userData?.space
  // public showAnnouncement = false;


  route(reference: Number, id: Number, type: Number, isActive: Boolean): void {
    if (isActive) {
      this.notificationsService.updateNotifications(
          Number(id),
          false
      ).subscribe((result: any) => {
        this.stateService.setUpdate(result?.data?.updateNotifications?.notifications?.id)
        this.link(type, reference)
      });
    } else {
      this.link(type, reference)
    }
  }



  link(type: Number, reference: Number){

    //broker
    if (this.space == "2") {
      // auto sinister
      if (type == 1 || type == 2 || type == 13) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/sinisters/auto/view/${reference.toString()}`])); window.open(url, '_blank')
      }

      // health sinister
      if (type == 3 || type == 4 || type == 14) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/sinisters/health/view/${reference.toString()}`])); window.open(url, '_blank')
      }

      // miscellaneous risk sinister
      if (type == 5 || type == 6 || type == 15) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/sinisters/risk/view/${reference.toString()}`])); window.open(url, '_blank')
      }

      // request external
      if (type == 9 || type == 7 || type == 8) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/requests/external/view/${reference.toString()}`])); window.open(url, '_blank')
      }

      // request internal
      if (type == 16 || type == 17 || type == 18 || type == 19) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/requests/internal/view/${reference.toString()}`])); window.open(url, '_blank')
      }

      // paiement client
      if (type == 20 || type == 21 || type == 22) {
        // let url = this.router.serializeUrl(this.router.createUrlTree([`/requests/internal/view/${reference.toString()}`])); window.open(url, '_blank')
      }

      // cotation client mono
      if (type == 23 || type == 24 || type == 25 || type == 28 || type == 30) {
        // let url = this.router.serializeUrl(this.router.createUrlTree([`/requests/internal/view/${reference.toString()}`])); window.open(url, '_blank')
      }


      // cotation client flotte
      if (type == 26 || type == 30 || type == 25) {
        // let url = this.router.serializeUrl(this.router.createUrlTree([`/requests/internal/view/${reference.toString()}`])); window.open(url, '_blank')
      }

      // cotation client voyage
      if (type == 27 || type == 29 || type == 34) {
        // let url = this.router.serializeUrl(this.router.createUrlTree([`/requests/internal/view/${reference.toString()}`])); window.open(url, '_blank')
      }


      // cotation client mrh et mrp
      if (type == 32 || type == 33) {
        // let url = this.router.serializeUrl(this.router.createUrlTree([`/requests/internal/view/${reference.toString()}`])); window.open(url, '_blank')
      }

      // annonce
      if (type == 35) {
        this.notificationsService.showAnnouncementPopup(reference);
      }
    }

    //clients
    if (this.space == "6") {
      // auto sinister
      if (type == 1 || type == 2 || type == 13) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/sinisters/auto/clients/list/${reference.toString()}`])); window.open(url, '_blank')
      }

      // health sinister
      if (type == 3 || type == 4 || type == 14) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/sinisters/health/clients/list/${reference.toString()}`])); window.open(url, '_blank')
      }

      // miscellaneous risk sinister
      if (type == 5 || type == 6 || type == 15) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/sinisters/risk/clients/list/${reference.toString()}`])); window.open(url, '_blank')
      }

      // request external
      if (type == 9 || type == 7 || type == 8) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/requests/clients/list/${reference.toString()}`])); window.open(url, '_blank')
      }
    }

    //providers
    if (this.space == "3") {
      // auto sinister
      if (type == 1 || type == 2 || type == 13) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/sinisters/auto/providers/view/${reference.toString()}`])); window.open(url, '_blank')
      }

      // health sinister
      if (type == 3 || type == 4 || type == 14) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/sinisters/health/providers/view/${reference.toString()}`])); window.open(url, '_blank')
      }

      // miscellaneous risk sinister
      if (type == 5 || type == 6 || type == 15) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/sinisters/risk/providers/view/${reference.toString()}`])); window.open(url, '_blank')
      }

      // request external
      if (type == 9 || type == 7 || type == 8) {
        let url = this.router.serializeUrl(this.router.createUrlTree([`/requests/providers/view/${reference.toString()}`])); window.open(url, '_blank')
      }
    }
  }



}
